/* =====================================================================
   Alex & Lace — background scroll-lock for the MENU DRAWER.

   Horizon's dialog-based overlays (predictive SEARCH + CART — both extend
   DialogComponent) already lock the page on open: body position:fixed with
   top:-scrollY, restored on close. The MENU drawer is different — it is
   <details>-based (header-drawer.js) and locks NOTHING, so the page scrolls
   behind it (the reported bug). This adds the SAME established lock for the
   menu drawer only:
     · open  → pin <body> (position:fixed, top:-scrollY, width:100%) so the
               background cannot move on wheel / trackpad / touch;
     · close → release and restore the EXACT scroll position (no jump).
   The root <details>'s `open` attribute is the trigger — Horizon removes it in
   reset() at close-COMPLETE in both the GSAP and reduced-motion/no-GSAP paths,
   so we never unlock mid-close.

   Runs on ALL devices (NOT gated to Lenis) — the lock must hold on mobile /
   reduced-motion / Lenis-off too. al-smooth-scroll.js separately detects the
   position:fixed lock and stops Lenis while it is held, so smooth-scroll can't
   fight it. Cart/search need no change here — DialogComponent already locks;
   the Lenis-detect update covers them.
   ===================================================================== */

(() => {
  const roots = document.querySelectorAll('details.menu-drawer-container');
  if (!roots.length) return;

  let locked = false;
  let lockedY = 0;

  const lock = () => {
    if (locked) return;
    locked = true;
    lockedY = window.scrollY || window.pageYOffset || 0;
    const b = document.body.style;
    b.width = '100%';
    b.position = 'fixed';
    b.top = `-${lockedY}px`;
  };

  const unlock = () => {
    if (!locked) return;
    locked = false;
    const b = document.body.style;
    b.width = '';
    b.position = '';
    b.top = '';
    window.scrollTo({ top: lockedY, behavior: 'instant' });
  };

  roots.forEach((root) => {
    const sync = () => (root.open ? lock() : unlock());
    // `toggle` fires whenever the <details> open state changes (open + animated close-complete).
    root.addEventListener('toggle', sync);
    // Belt-and-suspenders for any path that mutates `open` without firing toggle.
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['open'] });
    sync(); // reflect any already-open state (e.g. restored)
  });
})();
